import React from "react";

function Donut({value,max,color,size=72,label,sub}){
  const pct=max>0?Math.min(value/max,1):0;
  return(
    <div style={{textAlign:"center"}}>
      <div style={{position:"relative",width:size,height:size,margin:"0 auto 6px"}}>
        <svg viewBox="0 0 36 36" style={{width:size,height:size,transform:"rotate(-90deg)"}}>
          <circle cx="18" cy="18" r="15.9" fill="none" stroke="var(--g100)" strokeWidth="3"/>
          <circle cx="18" cy="18" r="15.9" fill="none" stroke={color} strokeWidth="3" strokeDasharray={`${pct*100} 100`} strokeLinecap="round"/>
        </svg>
        <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"var(--fm)",fontSize:size>60?14:11,fontWeight:700,color}}>{label}</div>
      </div>
      {sub&&<div style={{fontSize:11,color:"var(--g500)"}}>{sub}</div>}
    </div>
  );
}
function MultiDonut({segments,size=90}){
  let offset=0;
  return(
    <div style={{position:"relative",width:size,height:size,margin:"0 auto"}}>
      <svg viewBox="0 0 36 36" style={{width:size,height:size,transform:"rotate(-90deg)"}}>
        <circle cx="18" cy="18" r="15.9" fill="none" stroke="var(--g100)" strokeWidth="3.5"/>
        {segments.map((s,i)=>{const d=<circle key={i} cx="18" cy="18" r="15.9" fill="none" stroke={s.color} strokeWidth="3.5" strokeDasharray={`${s.pct} 100`} strokeDashoffset={`${-offset}`} strokeLinecap="round"/>;offset+=s.pct;return d;})}
      </svg>
    </div>
  );
}
function DashDonut({value,max,color,size=52,label}){
  const pct=max>0?Math.min(value/max,1):0;
  return(
    <div style={{position:"relative",width:size,height:size,flexShrink:0}}>
      <svg viewBox="0 0 36 36" style={{width:size,height:size,transform:"rotate(-90deg)"}}>
        <circle cx="18" cy="18" r="15.9" fill="none" stroke="var(--g100)" strokeWidth="3"/>
        <circle cx="18" cy="18" r="15.9" fill="none" stroke={color} strokeWidth="3" strokeDasharray={`${pct*100} 100`} strokeLinecap="round"/>
      </svg>
      {label&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"var(--fm)",fontSize:10,fontWeight:700,color}}>{label}</div>}
    </div>
  );
}
function DM({l,v,c,bold}){return <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0"}}><span style={{fontSize:12,color:"var(--g500)"}}>{l}</span><span style={{fontFamily:"var(--fm)",fontSize:13,fontWeight:bold?700:600,color:c||"var(--ink)"}}>{v}</span></div>;}

export { Donut, MultiDonut, DashDonut, DM };
